/* eslint-disable no-unused-vars */
import axios from "axios";

import { REQUEST, SUCCESS, ERROR, LOGIN, LOGOUT } from "@/store/actions/auth";

const state = {
  token: localStorage.getItem("dashboard.jumpfeed.com-jwt") || ""
};

const getters = {
  isAuthenticated: state => !!state.token
};

const actions = {
  [REQUEST]: ({ commit, dispatch }, userData) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: "https://api-v2.jumpfeed.com/internal/auth",
        data: userData,
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(resp => {
          const token = resp.data.data.token;
          commit(SUCCESS, token);
        })
        .then(resp => dispatch(LOGIN))
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          commit(ERROR);
          dispatch(LOGOUT).then(() => {
            reject(err);
          });
        });
    });
  },
  [LOGIN]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      const token = state.token;
      window.localStorage.setItem("dashboard.jumpfeed.com-jwt", token); // store the user's token in localstorage
      axios.defaults.headers.common["Authorization"] = "Bearer " + token; // add the token as a auth header for all requests, so all API calls are authenticated.

      // now that we have a token -> actually login the user by performing appropriate login actions, and then resolve our promise
      let loginActions = [dispatch("user/GET_REQUEST", null, { root: true })];

      Promise.all(loginActions)
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  [LOGOUT]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(LOGOUT);
      window.localStorage.removeItem("dashboard.jumpfeed.com-jwt"); // remove the token from localstorage
      delete axios.defaults.headers.common["Authorization"]; // remove the token from the auth header for all requests
      resolve();
    });
  }
};

const mutations = {
  [SUCCESS]: (state, token) => {
    state.token = token;
  },
  [ERROR]: state => {
    state.token = "";
  },
  [LOGOUT]: state => {
    state.token = "";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
